import React from 'react';
import { FolderInput, Brain, Home, FileText } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Drop your Desktop',
    body:
      'Point Sortio at the folder where everything lands: MLS photos, signed disclosures, drone shots, scanned settlement statements, downloaded inspection PDFs. Sortio scans them on your machine.',
  },
  {
    icon: Brain,
    title: 'AI reads each file',
    body:
      "Sortio's AI extracts property addresses, transaction parties, document types, and dates from each file. PDFs are read locally and photos are matched by visible signage, lockbox, and address metadata. By default Sortio uses our cloud (OpenAI) to plan the sort, sending filenames and folder paths (and file contents only if you enable a content-based feature). Run a local LLM (Ollama) or BYOK and nothing is uploaded to our servers at all.",
  },
  {
    icon: Home,
    title: 'Routed by property',
    body:
      'Each file is filed under the matching property folder (for example, 1127 S Cornell Terrace). Tax returns are routed to a separate yearly archive. You see a preview with confidence scores and can override any placement before files move.',
  },
  {
    icon: FileText,
    title: 'Renamed from content',
    body:
      "PDFs are renamed from what's inside, so 'scan_047.pdf' becomes 'ALTA Settlement Statement - 1127 S Cornell Terrace - 2026-04-12.pdf'. Listing photos get the property address in the filename. Your Desktop empties out and your folders stay clean.",
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How it works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a Desktop full of mixed files to clean, per-property transaction folders.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div
              key={i}
              className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col"
            >
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">
                  Step {i + 1}
                </span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
